var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', [_c('el-button', { attrs: { "type": "text" }, on: { "click": _vm.handleClick } }, [_vm._v(" " + _vm._s(_vm.btnText) + " ")]), _vm._v(" "), _c('preview-modal', { attrs: { "preview": _vm.previewDialog, "previewSource": 'basic' } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };